(ns dre.pages.admin.feed.db)

(def init-db
  {:feeds {:state :loading
           :data []}})
